import type { AxiosRequestConfig } from 'axios';
import axios from 'axios';
import type {
  SaveVirtualTourRequestBody,
  SaveVirtualTourResponseBody,
  JsonObject,
} from '@/app-package';

/**
 * Creates a new virtual tour
 * @param newTour - The virtual tour data to save
 */
const saveVirtualTour = async (
  newTour: JsonObject<SaveVirtualTourRequestBody['newTour']>,
) => {
  const config: AxiosRequestConfig = {
    url: `/virtual_tour`,
    method: 'post',
    data: { newTour },
  };

  const { data } =
    await axios.request<JsonObject<SaveVirtualTourResponseBody>>(config);

  return data;
};

export default saveVirtualTour;
